import { RelevantPhrasesEditorValue, RelevantPhrasesState, RelevantPhrasesValue } from '../typings/relevantPhrases';

export function mapRelevantPhrasesEditorValueToCampaignRelevantPhrasesValue(
    relevantPhrases: RelevantPhrasesState
): RelevantPhrasesValue {
    const limit = relevantPhrases.limit;

    return {
        isEnabled: relevantPhrases.isEnabled,
        limit: Number(limit),
        goalId: relevantPhrases.goalId
    };
}

export function mapCampaignRelevantPhrasesValueToRelevantPhrasesEditorValue(
    relevantPhrases: RelevantPhrasesValue
): RelevantPhrasesEditorValue {
    const limit = relevantPhrases.limit;

    return {
        isEnabled: relevantPhrases.isEnabled,
        limit: limit === undefined ? '' : String(limit),
        goalId: relevantPhrases.goalId
    };
}
